import { submitUpdateMessageFlow } from './submitUpdateMessageFlow'
import { submitUpdateLabelFlow } from './submitUpdateLabelFlow'

export const submitUpdateFlows = [
  submitUpdateMessageFlow,
  submitUpdateLabelFlow,
]
